import { render, staticRenderFns } from "./LSMSKastenLayer.vue?vue&type=template&id=2bfec5e6&"
import script from "./LSMSKastenLayer.vue?vue&type=script&lang=js&"
export * from "./LSMSKastenLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports